<template>
  <div class="root_layout">
    <van-loading type="spinner" size="30px" text-size="18px">{{showText}}</van-loading>
  </div>
</template>

<script>
import * as common from '../../api/common'

export default {
  name: 'codeObtain',
  data () {
    return {
      showText: '加载中...'
    }
  },
  mounted () {
    // 旧方法
    // let code
    // if (common.getUserAgent() === 'wx') {
    //   code = this.getUrlParam('code')
    // } else if (common.getUserAgent() === 'zfb') {
    //   code = this.$route.query.auth_code
    // }
    // if (!code) {
    //   this.skipError('获取 code 失败')
    //   return
    // }

    // const targetFullUrl = this.$route.query.url
    // console.log('targetFullUrl', targetFullUrl)
    // if (!targetFullUrl) {
    //   this.skipError('目标 url 不存在')
    //   return
    // }

    // let targetBaseUrl
    // const curBaseUrl = common.getUrlObjBase(window.location)
    // console.log('curBaseUrl', curBaseUrl)
    // try {
    //   targetBaseUrl = common.getUrlObjBase(new URL(targetFullUrl))
    //   console.log('targetBaseUrl', targetBaseUrl)
    // } catch (e) {
    //   this.skipError('解析 url 失败')
    //   return
    // }

    // if (targetBaseUrl !== curBaseUrl) {
    //   this.skipError('目标 url 域名路径异常')
    //   return
    // }

    // let newTargetFullUrl
    // if (common.getUserAgent() === 'wx') {
    //   newTargetFullUrl = this.addParamVal(targetFullUrl, 'code', code)
    //   window.location.replace(newTargetFullUrl)
    // } else if (common.getUserAgent() === 'zfb') {
    //   newTargetFullUrl = this.addParamVal(targetFullUrl, 'auth_code', code)
    //   this.ZFBReady(function () {
    //     // eslint-disable-next-line no-undef
    //     AlipayJSBridge.call('pushWindow', {
    //       url: newTargetFullUrl,
    //       param: {
    //         closeCurrentWindow: true
    //       }
    //     })
    //   })
    // }
    // 新方法
    let code
    if (common.getUserAgent() === 'wx') {
      code = this.getUrlParam('code')
    } else if (common.getUserAgent() === 'zfb') {
      code = this.$route.query.auth_code
    }

    // this.$toast.success(`回来时的code${JSON.parse(this.$route.query)}`)
    // this.$toast.success(`回来时的code${window.location.href}`)

    const plateNumber = this.getPlateNumberFromHashUrl()
    console.log('plateNumber:', plateNumber)

    // this.$toast.success(`回来时的code${JSON.parse(this.$route.query)}`)
    // this.$toast.success(`回来时的code${code}${plateNumber}`)
    const savedQuery = JSON.parse(localStorage.getItem(`urlQueryInfo:${plateNumber}`) || '{}')

    // this.$toast.success(`刚才保存的savedQuery${savedQuery}`)
    if (!plateNumber || !savedQuery || Object.keys(savedQuery).length === 0) {
    // this.skipError('找不到缓存的参数')
    // return
    }

    // todo code已经成功拿回 需要根据车牌号
    if (!code) {
      this.skipError('获取 code 失败')
      return
    }
    const targetFullUrl = this.$route.query.url
    console.log('targetFullUrl', targetFullUrl)// https://paycloud.test.szzcloud.club/?plate_number=%E6%B5%99AQQ222#/vh_fee_order_escape_out

    if (!targetFullUrl) {
      this.skipError('目标 url 不存在')
      return
    }

    let targetBaseUrl
    const curBaseUrl = common.getUrlObjBase(window.location)
    console.log('curBaseUrl', curBaseUrl)// https://paycloud.test.szzcloud.club/#

    try {
      targetBaseUrl = common.getUrlObjBase(new URL(targetFullUrl))
      console.log('targetBaseUrl', targetBaseUrl) // https://paycloud.test.szzcloud.club/#
    } catch (e) {
      this.skipError('解析 url 失败')
      return
    }

    if (targetBaseUrl !== curBaseUrl) {
      this.skipError('目标 url 域名路径异常')
      return
    }
    // this.$dialog.alert({
    //     // showCancelButton: true,
    //     title: '提示',
    //     message: targetBaseUrl
    //   }).then(() => {
    //   })
    //   return
    let newTargetFullUrl
    if (common.getUserAgent() === 'wx') {
      const fullUrlObj = new URL(targetFullUrl)
      const hash = fullUrlObj.hash || ''
      let pagePath = ''

      if (hash.startsWith('#')) {
        pagePath = hash.slice(1) // 去掉 '#'
      } else {
        pagePath = hash
      }
      // 如果有 '?'，说明有参数，需要只取 '?' 前面的路径
      if (pagePath.includes('?')) {
        pagePath = pagePath.split('?')[0]
      }
      // 目前只有微信-欠费关闭时和欠费开启时 需要处理
      if (pagePath !== '/vh_fee_order_escape_out' && pagePath !== '/payMoney' && pagePath !== '/fee_in_escape') {
        newTargetFullUrl = this.addParamVal(targetFullUrl, 'code', code)
        window.location.replace(newTargetFullUrl)
      } else {
      // TODO 新方法
        // 把 code 也加进去
        savedQuery.code = code

        // 构造新的 URL
        // const newUrl = new URL(window.location.origin + '/')
        // newUrl.hash = '#/vh_fee_order_escape_out'
        // 用 URL 对象解析 targetFullUrl

        // pagePath需要前置：如果为月租缴费时 不需要使用新方法。
        const newUrl = new URL(window.location.origin + '/')
        newUrl.hash = pagePath

        // 把 query 参数拼接到 hash 后面
        const searchParams = new URLSearchParams()
        Object.entries(savedQuery).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            searchParams.set(key, String(value))
          }
        })
        newUrl.hash += '?' + searchParams.toString()

        // 重定向
        window.location.replace(newUrl.toString())
      }
    } else if (common.getUserAgent() === 'zfb') {
      newTargetFullUrl = this.addParamVal(targetFullUrl, 'auth_code', code)
      this.ZFBReady(function () {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('pushWindow', {
          url: newTargetFullUrl,
          param: {
            closeCurrentWindow: true
          }
        })
      })
    }
  },
  methods: {
    // 获取 url 中的 plate_number
    getPlateNumberFromHashUrl () {
      // 第一步：拿到 hash 部分的 query
      const hash = window.location.hash || ''
      const queryStr = hash.split('?')[1] || ''
      const query = {}
      queryStr.split('&').forEach(kv => {
        const [key, val] = kv.split('=')
        if (key) query[key] = decodeURIComponent(val || '')
      })

      // 第二步：拿到并解码 url 参数
      const fullEncodedUrl = query.url
      if (!fullEncodedUrl) return null

      try {
        const decodedUrl = decodeURIComponent(decodeURIComponent(fullEncodedUrl))
        const urlObj = new URL(decodedUrl)
        const plateNumber = urlObj.searchParams.get('plate_number')
        return plateNumber
      } catch (e) {
        console.error('解析 plate_number 失败', e)
        return null
      }
    },

    getUrlParam (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
      const r = window.location.search.substring(1).match(reg) // 匹配目标参数
      if (r != null) {
        return decodeURIComponent(r[2])
      }
      return null // 返回参数值
    },
    addParamVal (url, paramName, paramValue) {
      const re = new RegExp(`(${paramName}=)([^&]*)`, 'gi')
      let newUrl
      if (url.match(re)) {
        // newUrl = url.replace(re, "$1" + paramName + "=" + paramValue + "$2");
        newUrl = url.replace(re, `${paramName}=${encodeURIComponent(paramValue)}`)
      } else {
        const separator = url.indexOf('?') !== -1 ? '&' : '?'
        newUrl = url + separator + paramName + '=' + encodeURIComponent(paramValue)
      }
      return newUrl
    },
    skipError (msg) {
      this.$dialog.alert({
        title: '提示',
        message: msg || '跳转参数出错'
      }).then(() => {
        this.showText = '关闭页面中...'
        if (common.getUserAgent() === 'wx') {
          this.WX_Bridge_ready(() => {
            // eslint-disable-next-line no-undef
            WeixinJSBridge.call('closeWindow')
          })
        } else if (common.getUserAgent() === 'zfb') {
          this.ZFBReady(() => {
            // ap.popWindow()
            // eslint-disable-next-line no-undef
            AlipayJSBridge.call('popWindow', {
              data: {
                from: location.href,
                info: Date.now()
              }
            })
          })
        }
      })
    },
    WX_Bridge_ready (cb) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', cb(), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', cb())
          document.attachEvent('onWeixinJSBridgeReady', cb())
        }
      } else {
        cb()
      }
    },
    ZFBReady (callback) {
      if (window.AlipayJSBridge) {
        callback && callback()
      } else {
        if (document.addEventListener) {
          document.addEventListener('AlipayJSBridgeReady', callback, false)
        } else if (document.attachEvent) {
          document.attachEvent('AlipayJSBridgeReady', callback)
        }
      }
    }
  }
}
</script>

<style scoped>
.root_layout{
  position: absolute;
  margin: 0;
  padding: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
